import Vue from 'vue'
import Router from 'vue-router'
import systemRegister from '@/components/systemRegister'
import bossRegister from '@/views/Register/bossRegister'

import bossInfo from '@/views/Register/bossInfo'
import workInfo from '@/views/Register/workerInfo'
import wetest from '@/views/Register/wetest'
import workerRegister from '@/views/Register/workerRegister'
import deptMan from '@/views/deptManage/deptMan'
import center from '@/views/storeRegister/center'
// import salesmanInspect from '@/views/PCManage/salesmanInspect'
// import manageSystem from '@/views/PCManage/manageSystem'
// import manageInfo from '@/views/PCManage/manageInfo'
import bossShops from '@/views/deptManage/bossShops'
import Public from '../components/Public'
import chainShops from "../views/deptManage/chainShops";
import chainRegister from "../views/Register/chainRegister";
import chainInfo from "../views/Register/chainInfo";

/**
 * 以下是京东建店的路由（新增项）
 */
import jdRegister from "@/components/jdRegister";
import jdbossInfo from '../views/jdRegister/jdbossInfo';
import jdbossRegister from '../views/jdRegister/jdbossRegister';
import jdchainInfo from '../views/jdRegister/jdchainInfo';
import jdchainRegister from "../views/jdRegister/jdchainRegister"
import jdworkerRegister from "../views/jdRegister/jdworkerRegister";
import jdworkerInfo from "../views/jdRegister/jdworkerInfo";
import jdwetest from '../views/jdRegister/jdwetest';
import jdbaseInfoRegister from '../views/jdstoreRegister/jdbaseInfoRegister';
import jdcenter from '@/views/jdstoreRegister/jdcenter';
import jdcredInfoRegister from '../views/jdstoreRegister/jdcredInfoRegister';
import jddeptRegister from '../views/jdstoreRegister/jddeptRegister';
import jdbossShops from '../views/jdDeptManage/jdbossShops'
import jdchainShops from '../views/jdDeptManage/jdchainShops'
import jddeptMan from '../views/jdDeptManage/jddeptMan'
// import manageBind from "../views/PCManage/manageBind";
// import EpiPreCtrl from '@/components/EpiPreCtrl'
// import epi_preCtrl from '@/views/EpiPreCtrl/epi_preCtrl'
// import epiStatus from '@/views/EpiPreCtrl/epiStatus'

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'systemRegister',
            meta: {
                layout: 'wx'
            },
            component: systemRegister
        },
        {
            path: '/bossRegister',
            name: 'bossRegister',
            meta: {
                layout: 'wx'
            },
            component: bossRegister
        },
        {
            path: '/bossInfo',
            name: 'bossInfo',
            meta: {
                layout: 'wx'
            },
            component: bossInfo
        },
        {
            path: '/wetest',
            name: 'wetest',
            meta: {
                layout: 'wx'
            },
            component: wetest
        },
        {
            path: '/chainShops',
            name: 'chainShops',
            meta: {
                layout: 'wx'
            },
            component: chainShops
        },
        {
            path: '/workerRegister',
            name: 'workerRegister',
            meta: {
                layout: 'wx'
            },
            component: workerRegister
        },
        //chainRegister
        {
            path: '/chainRegister',
            name: 'chainRegister',
            meta: {
                layout: 'wx'
            },
            component: chainRegister
        },
        {
            path: '/workInfo',
            name: 'workInfo',
            meta: {
                layout: 'wx'
            },
            component: workInfo
        },
        {
            path: '/chainInfo',
            name: 'chainInfo',
            meta: {
                layout: 'wx'
            },
            component: chainInfo
        },
        {
            path: '/deptMan',
            name: 'deptMan',
            meta: {
                layout: 'wx'
            },
            component: deptMan
        },
        {
            path: '/center/:id',
            name: 'center',
            meta: {
                layout: 'wx'
            },
            component: center
        },
        {
            path: '/bossShops',
            name: 'bossShops',
            meta: {
                layout: 'wx'
            },
            component: bossShops
        },
        {
            path: '/Public',
            name: 'Public',
            meta: {
                layout: 'wx'
            },
            component: Public
        },

        /**
         * 以下是京东建店的路由（新增项）
         */
        {
            path: '/jd',
            name: 'jdRegister',
            meta: {
                layout: 'jd'
            },
            component: jdRegister
        },
        {
            path: '/jdbossShops',
            name: 'jdbossShops',
            meta: {
                layout: 'jd'
            },
            component: jdbossShops
        },
        {
            path: '/jdchainShops',
            name: 'jdchainShops',
            meta: {
                layout: 'jd'
            },
            component: jdchainShops
        },
        {
            path: '/jddeptMan',
            name: 'jddeptMan',
            meta: {
                layout: 'jd'
            },
            component: jddeptMan
        },
        {
            path: '/jdbossInfo',
            name: 'jdbossInfo',
            meta: {
                layout: 'jd'
            },
            component: jdbossInfo
        },
        {
            path: '/jdbossRegister',
            name: 'jdbossRegister',
            meta: {
                layout: 'jd'
            },
            component: jdbossRegister
        },
        {
            path: '/jdchainInfo',
            name: 'jdchainInfo',
            meta: {
                layout: 'jd'
            },
            component: jdchainInfo
        },
        {
            path: '/jdchainRegister',
            name: 'jdchainRegister',
            meta: {
                layout: 'jd'
            },
            component: jdchainRegister
        },
        {
            path: '/jdworkerRegister',
            name: 'jdworkerRegister',
            meta: {
                layout: 'jd'
            },
            component: jdworkerRegister
        },
        {
            path: '/jdworkerInfo',
            name: 'jdworkerInfo',
            meta: {
                layout: 'jd'
            },
            component: jdworkerInfo
        },
        {
            path: '/jdwetest',
            name: 'jdwetest',
            meta: {
                layout: 'jd'
            },
            component: jdwetest
        },
        {
            path: '/jdbaseInfoRegister',
            name: 'jdbaseInfoRegister',
            meta: {
                layout: 'jd'
            },
            component: jdbaseInfoRegister
        },
        {
            path: '/jdcenter/:id',
            name: 'jdcenter',
            meta: {
                layout: 'jd'
            },
            component: jdcenter
        },
        {
            path: '/jddeptRegister',
            name: 'jddeptRegister',
            meta: {
                layout: 'jd'
            },
            component: jddeptRegister
        },
        {
            path: '/jdcredInfoRegister',
            name: 'jdcredInfoRegister',
            meta: {
                layout: 'jd'
            },
            component: jdcredInfoRegister
        },

        /**
         * 扫码进来后的门店电子签名页面
         */
        {
            path: '/electricSig',
            name: 'electricSig',
            meta: {
                layout: 'wx'
            },
            component: () => import('@/views/electricSig/index')
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js